import { render, staticRenderFns } from "./EnvelopeActionsBar.vue?vue&type=template&id=49f515a5&scoped=true&lang=pug"
import script from "./EnvelopeActionsBar.vue?vue&type=script&lang=js"
export * from "./EnvelopeActionsBar.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeActionsBar.vue?vue&type=style&index=0&id=49f515a5&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f515a5",
  null
  
)

export default component.exports